import React from 'react'
import styled from '@emotion/styled'

import { StringUtils } from '../../utils/siteUtils'

import { FlexDiv } from '../generic/Basics'
import { fontFamilyOpenSans, fontSize2XSmall, fontSizeMedium, fontWeightBold } from '../../constants/principles'

export default ({ year, make, model, trim = '' }) => (
  <FullWidthFlexDiv>
    {year && make && model && <StyledDiv>Your Vehicle Details</StyledDiv>}
    <StyledH2>{year && make && model ? `${year} ${StringUtils.upperCaseFirstLetter(make)} ${StringUtils.upperCaseFirstLetter(model)} ${StringUtils.upperCaseFirstLetter(trim)}` : 'Tell Us About Your Car'}</StyledH2>
  </FullWidthFlexDiv>
)

const FullWidthFlexDiv = styled(FlexDiv)`
  width: 100%;
`
const StyledDiv = styled.div`
  text-align: center;
  margin-bottom: 16px;
  font-weight: ${fontWeightBold};
  font-size: ${fontSize2XSmall};
  font-family: ${fontFamilyOpenSans};
  font-weight: inherit;
`
const StyledH2 = styled.h2`
  text-align: center;
  line-height: 26px;
  margin-bottom: 16px;
  font-size: ${fontSizeMedium};
  font-family: ${fontFamilyOpenSans};
  font-weight: inherit;
  width: 100%;
`
